// removed by extract-text-webpack-plugin
module.exports = {"numberInfo":"antd-pro-number-info-numberInfo","suffix":"antd-pro-number-info-suffix","numberInfoTitle":"antd-pro-number-info-numberInfoTitle","numberInfoSubTitle":"antd-pro-number-info-numberInfoSubTitle","numberInfoValue":"antd-pro-number-info-numberInfoValue","subTotal":"antd-pro-number-info-subTotal","numberInfolight":"antd-pro-number-info-numberInfolight"};


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/ant-design-pro-site/scaffold/src/components/NumberInfo/index.less
// module id = 633
// module chunks = 0